import { initErrorReporting } from '@tcc/scarecrow';

/**
 * Initialize scarecrow error reporting
 * @return {Promise}
 */
export default function setup() {

  initErrorReporting({});

  return Promise.resolve(true);
}
